import type { HelpFile } from '../../types/help'
import { EmailConfigCardTestIds } from '../../../testids/EmailConfigCardTestIds'

export const emailConfigCardHelp: HelpFile = {
  docPage: '/docs/systems/connectors',
  texts: {
    [EmailConfigCardTestIds.emailConfigCard]:
      'E-Mail-Konfiguration des Konnektors — legt fest, wie E-Mails an das Zielsystem zusammengestellt und versendet werden.',
    [EmailConfigCardTestIds.cardTitleEmailConfig]: null,
    [EmailConfigCardTestIds.emailNotConfigured]:
      'Keine E-Mail-Konfiguration vorhanden — ohne sie kann dieser Konnektor keine Nachrichten versenden.',
    [EmailConfigCardTestIds.btnCreateEmailConfig]: null,
    [EmailConfigCardTestIds.btnEditEmailConfig]: null,
    [EmailConfigCardTestIds.selectBodyContentType]:
      'Legt fest, ob ausgehende Nachrichten als reiner Text oder als HTML versendet werden.',
  },
}
